import { createAppSelector, selectCurrentUserId, selectOrgUsers } from "./base";
import type { EnabledOrgUser } from "./types";

import type { RootState } from "store";

export const selectCurrentOrg = createAppSelector(
  [(state: RootState) => state.orgs],
  (orgs) => Object.values(orgs).find((o) => o.current) || null,
);

export const selectLmsType = createAppSelector([selectCurrentOrg], (org) => org?.lms_type || null);

export const selectCurrentOrgName = createAppSelector(
  [selectCurrentOrg],
  (org) => org?.name || null,
);

export const selectEnabledOrgUsers = createAppSelector(
  [selectOrgUsers],
  (orgUsers) => orgUsers.filter((ou) => !ou.is_disabled) as EnabledOrgUser[],
);

export const selectOrgUserByUserIdMap = createAppSelector(
  [selectOrgUsers, selectCurrentOrg],
  (orgUsers, currentOrg) =>
    Object.fromEntries(
      orgUsers.filter((ou) => ou.org_id === currentOrg?.id).map((ou) => [ou.user_id, ou]),
    ),
);

export const selectCurrentOrgRole = createAppSelector(
  [selectOrgUsers, selectCurrentUserId],
  (orgUsers, userId) => {
    const orgUser = orgUsers.find((ou) => ou.user_id === userId);
    return orgUser?.role || null;
  },
);

export const selectOrgRoleByUserId = createAppSelector(
  [selectOrgUsers, (state, userId: string) => userId],
  (orgUsers, userId) => {
    const orgUser = orgUsers.find((ou) => ou.user_id === userId);
    return orgUser?.role || null;
  },
);

export const selectOrgUserByUserId = createAppSelector(
  [selectOrgUserByUserIdMap, (state, userId: string) => userId],
  (orgUserMap, userId) => orgUserMap[userId] || null,
);

export const selectIsOrgUserDisabled = createAppSelector(
  [selectOrgUserByUserId],
  (orgUser) => orgUser?.is_disabled || false,
);
